export default __webpack_public_path__ + "static/media/issa.1266cc57.jpeg";